<template>
  <div class="visitor_container">
    <font-awesome-icon icon="desktop" style="font-size: 2rem" />
    <br />
    total page view
    <br />
    <h1>
      {{ this.totalCount }}
    </h1>
  </div>
</template>

<script>
import firebase from "firebase";

export default {
  name: "Visitor",
  data() {
    return {
      totalCount: null
    };
  },
  mounted() {
    firebase
      .database()
      .ref()
      .child("visitor")
      .once("value", sn => {
        this.totalCount = sn.val().value;
      });
  }
};
</script>

<style>
.visitor_container {
  padding-top: 30px;
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  justify-content: top;
}
</style>
